import { createColumnHelper } from '@tanstack/react-table';

import { ClosedLot, FilterType } from '../_openapi/portfolio-optimizer';
import { getAvailableAssetClasses, getAvailableAssetTypes, getAvailableSubAssetTypes } from '../utils/assetUtils';
import { AssetClassTag } from '../widgets/AssetClassTag';
import { baseCol, dateCol, moneyCol, numberCol, textCol } from '../widgets/Table/columnHelpers/colDef';
import { FlagCell } from '../widgets/Table/FlagCell';

const columnHelper = createColumnHelper<ClosedLot>();
export const closedLotListColumns = [
    columnHelper.accessor('tradeDate', dateCol({ id: 'tradeDate' })),
    columnHelper.accessor('pId', textCol({ id: 'pId' })),
    columnHelper.accessor('portfolioGuid', textCol({ id: 'portfolioGuid' })),
    columnHelper.accessor('portfolioName', textCol({ id: 'portfolioName' })),
    columnHelper.accessor('householdName', textCol({ id: 'householdName' })),
    columnHelper.accessor('aC', textCol({ id: 'aC' })),
    columnHelper.accessor('sId', textCol({ id: 'sId' })),
    columnHelper.accessor('closedLotId', textCol({ id: 'closedLotId' })),
    columnHelper.accessor('symbol', textCol({ id: 'symbol' })),
    columnHelper.accessor('description', textCol({ id: 'description' })),
    columnHelper.accessor('assetClass', {
        ...baseCol({ id: 'assetClass' }),
        cell: ({ getValue }) => <AssetClassTag assetClass={getValue()} />,
        meta: {
            filterOptionsFn: getAvailableAssetClasses,
            filterType: FilterType.LIST,
        },
    }),
    columnHelper.accessor(
        'assetType',
        textCol({
            id: 'assetType',
            meta: {
                filterOptionsFn: getAvailableAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor(
        'subAssetType',
        textCol({
            id: 'subAssetType',
            meta: {
                filterOptionsFn: getAvailableSubAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor('quantity', numberCol({ id: 'quantity' })),
    columnHelper.accessor('tradePrice', moneyCol({ id: 'tradePrice' })),
    columnHelper.accessor('costBasis', moneyCol({ id: 'costBasis' })),
    columnHelper.accessor('pnlRealized', moneyCol({ id: 'pnlRealized' })),
    columnHelper.accessor('returnRealized', numberCol({ id: 'returnRealized', format: { style: 'percent' } })),
    columnHelper.accessor('side', textCol({ id: 'side' })),
    columnHelper.accessor('referencePortfolio', textCol({ id: 'referencePortfolio' })),
    columnHelper.accessor('allocationType', textCol({ id: 'allocationType' })),
    columnHelper.accessor('investmentAlgo', textCol({ id: 'investmentAlgo' })),
    columnHelper.accessor('investmentSleeve', textCol({ id: 'investmentSleeve' })),
    columnHelper.accessor('nav', moneyCol({ id: 'nav' })),
    columnHelper.accessor('scId', textCol({ id: 'scId' })),
    columnHelper.accessor('coId', textCol({ id: 'coId' })),
    columnHelper.accessor('priceMultiplier', numberCol({ id: 'priceMultiplier' })),
    columnHelper.accessor('contractMultiplier', numberCol({ id: 'contractMultiplier' })),
    columnHelper.accessor('primaryExchange', textCol({ id: 'primaryExchange' })),
    columnHelper.accessor('cusip', textCol({ id: 'cusip' })),
    columnHelper.accessor('isin', textCol({ id: 'isin' })),
    columnHelper.accessor('sedol', textCol({ id: 'sedol' })),
    columnHelper.accessor('country', {
        ...baseCol({ id: 'country' }),
        cell: ({ getValue }) => <FlagCell alpha3={getValue()} />,
    }),
    columnHelper.accessor('mic', textCol({ id: 'mic' })),
    columnHelper.accessor('gicsCode', textCol({ id: 'gicsCode' })),
    columnHelper.accessor('gicsSector', textCol({ id: 'gicsSector' })),
    columnHelper.accessor('gicsIndustry', textCol({ id: 'gicsIndustry' })),
    columnHelper.accessor('issuer', textCol({ id: 'issuer' })),
    columnHelper.accessor('coupon', numberCol({ id: 'coupon' })),
    columnHelper.accessor('maturityDate', dateCol({ id: 'maturityDate' })),
    columnHelper.accessor('issueDate', dateCol({ id: 'issueDate' })),
    columnHelper.accessor('expirationDate', dateCol({ id: 'expirationDate' })),
    columnHelper.accessor('firstNoticeDate', dateCol({ id: 'firstNoticeDate' })),
    columnHelper.accessor('settlementMethod', textCol({ id: 'settlementMethod' })),
    columnHelper.accessor('minTick', numberCol({ id: 'minTick' })),
    columnHelper.accessor('putCall', textCol({ id: 'putCall' })),
    columnHelper.accessor('underlyingSymbol', textCol({ id: 'underlyingSymbol' })),
    columnHelper.accessor('brokerId', textCol({ id: 'brokerId' })),
];
